import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pelanggan',
  templateUrl: './pelanggan.component.html',
  styleUrls: ['./pelanggan.component.scss']
})
export class PelangganComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
